<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm_3">
<p class="chapterTitle">Abbreviations</p>
<p class="NoIndent">[Note: additional abbreviations for frequently cited books and standard reference works are found at the beginning of the bibliography]</p>
<div class="extract">
<p class="FMaltPara">ABA = American Bar Association</p>
<p class="FMaltPara">AEF = Allied Expeditionary Force (World War I)</p>
<p class="FMaltPara">AlaDI = Alabama Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">AlaDivI = Alabama Divorce Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">AlaMI = Alabama Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">AMA = American Medical Association</p>
<p class="FMaltPara">Anc. = Ancestor(s)/Ancestry</p>
<p class="FMaltPara"><a href="http://Anc.com" target="_blank">Anc.com</a> = <a href="http://Ancestry.com" target="_blank">Ancestry.com</a></p>
<p class="FMaltPara"><a href="http://Anc.com" target="_blank">Anc.com</a>/Historical Newspapers = Historical Newspapers, Birth, Marriage &amp; Death Announcements, 1851–2003 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara"><a href="http://Anc.com" target="_blank">Anc.com</a>/Dept. of Veterans Affairs = U.S. Department of Veterans Affairs BIRLS Death File, 1850–2010 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">ANV = Army of Northern Virginia</p>
<p class="FMaltPara">ArizMI = Arizona Marriage Index (“Arizona Marriages”; database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">ArkDI = Arkansas Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">ArkMI = Arkansas Marriage Index (“Arkansas Marriages”; database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">Assn. = Association</p>
<p class="FMaltPara">AWOL = absent without leave</p>
<p class="FMaltPara">AWT = Ancestry World Tree (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
</div>
<div class="extract">
<p class="FMaltPara">b. = born</p>
<p class="FMaltPara">B.C. = British Columbia</p>
<p class="FMaltPara">B.D. = Bachelor of Divinity</p>
<p class="FMaltPara">B.F.A. = Bachelor of Fine Arts</p>
<p class="FMaltPara">bibliog. = bibliography</p>
<p class="FMaltPara">Biog. = Biography/Biographical</p>
<p class="FMaltPara">B.N. = Bachelor of Nursing</p>
</div>
<div class="extract">
<p class="FMaltPara">CalBI = California Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">CalDI = California Death Records (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">CalMI = California Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">Capt. = Captain</p>
<p class="FMaltPara">CDA = National Society of the Colonial Dames of America</p>
<p class="FMaltPara">cem. = cemetery</p>
<p class="FMaltPara">CEO = Chief Executive Officer</p>
<p class="FMaltPara">CFO = Chief Financial Officer</p>
<p class="FMaltPara">chap. = chapter</p>
<p class="FMaltPara">CIA = Central Intelligence Agency</p>
<p class="FMaltPara">Co. (in clearly military contexts) = Company</p>
<p class="FMaltPara">Co. (except in military contexts) = County</p>
<p class="FMaltPara">ConnDI = Connecticut Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">CPA = Certified Public Accountant</p>
<p class="FMaltPara">Cpl. = Corporal</p>
<p class="FMaltPara">CPO = Chief Petty Officer</p>
<p class="FMaltPara">CSA = Confederate States Army</p>
<p class="FMaltPara">CSN = Confederates States Navy</p>
<p class="FMaltPara"><em class="italic">CV = Confederate Veteran</em></p>
<p class="FMaltPara">CV = Curriculum Vitae</p>
<p class="FMaltPara">Cycl. = Cyclop(a)edia</p>
</div>
<div class="extract">
<p class="FMaltPara">d. = died</p>
<p class="FMaltPara">DAR and NSDAR = National Society of the Daughters of the American Revolution</p>
<p class="FMaltPara">D.D. = Doctor of Divinity</p>
<p class="FMaltPara">desc. = descendant(s)</p>
<p class="FMaltPara">DFC = Distinguished Flying Cross</p>
<p class="FMaltPara">Dicty. = Dictionary</p>
<p class="FMaltPara">Dir. = Directory</p>
<p class="FMaltPara">Div. = Division (except in academic degrees, where it means “Divinity”)</p>
<p class="FMaltPara">D.Min. = Doctor of Ministry</p>
<p class="FMaltPara"><em class="italic">d.s.p.</em> = died without issue (<em class="italic">decessit sine prole</em>)</p>
</div>
<div class="extract">
<p class="FMaltPara">E.D. = Enumeration District</p>
<p class="FMaltPara">Enc. = Encyclop(a)edia</p>
</div>
<div class="extract">
<p class="FMaltPara">Fam. = Family/Families</p>
<p class="FMaltPara"><a href="http://FamSearch.org" target="_blank">FamSearch.org</a> = <a href="http://FamilySearch.org" target="_blank">FamilySearch.org</a> (a non-profit website maintained by the Church of Jesus Christ of Latter-day Saints)</p>
<p class="FMaltPara"><a href="http://FamSearch.org" target="_blank">FamSearch.org</a>/AF = <a href="http://FamilySearch.org" target="_blank">FamilySearch.org</a>/Ancestry File (database on <a href="http://FamilySearch.org" target="_blank">FamilySearch.org</a>)</p>
<p class="FMaltPara"><a href="http://FamSearch.org" target="_blank">FamSearch.org</a>/PRF = <a href="http://FamilySearch.org" target="_blank">FamilySearch.org</a>/Pedigree Resource File (database on <a href="http://FamilySearch.org" target="_blank">FamilySearch.org</a>)</p>
<p class="FMaltPara">FGS = Family Group Sheet (an unpublished genealogical chart, often undocumented and based on personal knowledge)</p>
<p class="FMaltPara">FlaDI = Florida Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">FlaDivI = Florida Divorce Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
</div>
<div class="extract">
<p class="FMaltPara">GaDI = Georgia Death Index (database accessible on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">Ga. Tech = Georgia Institute of Technology</p>
<p class="FMaltPara">GEDCOM = GEnealogical Data COMmunication (electronically shared family tree; more technically, a process for sharing data between different genealogy software programs)</p>
<p class="FMaltPara"><a href="http://Gen.com" target="_blank">Gen.com</a>/WFT = <a href="http://Genealogy.com" target="_blank">Genealogy.com</a>/World Family Tree</p>
</div>
<div class="extract">
<p class="FMaltPara">HEW = U.S. Department of Health, Education and Welfare</p>
<p class="FMaltPara">Hist. = History/Historical</p>
</div>
<div class="extract">
<p class="FMaltPara">ibid. = in the same place</p>
<p class="FMaltPara">IdaDI = Idaho Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">IdaMI = Idaho Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara"><em class="italic">IGI</em> = International Genealogical Index (accessible on the web-site <a href="http://FamilySearch.org" target="_blank">FamilySearch.org</a>)</p>
<p class="FMaltPara">IllDI = Illinois Death Index (“Illinois Deaths and Stillbirths,” a database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">IllMarrI = Illinois Marriage Records (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">IndBI = Indiana Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">IndMI = Indiana Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">IowaBI = Iowa Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
</div>
<div class="extract">
<p class="FMaltPara">JAG = Judge Advocate General</p>
<p class="FMaltPara">J.A.W. = John Augustine Washington (of Chevy Chase, later Bethesda, Md.; author of the unpublished <em class="italic">Outline</em> that became a major component of the current book. For many years he collaborated extensively with Prentiss Price, of Rogersville, Tenn.)</p>
<p class="FMaltPara">Jur.Sc.D. = Doctor of Legal Science</p>
</div>
<div class="extract">
<p class="FMaltPara">KyBI = Kentucky Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">KyDI = Kentucky Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">KyMI = Kentucky Marriage Records (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>) <span class="bold"></span></p>
</div>
<div class="extract">
<p class="FMaltPara">LCT = Landing Craft Tanks</p>
<p class="FMaltPara">LDS = Church of Jesus Christ of Latter-day Saints</p>
<p class="FMaltPara">LL.B. = Bachelor of Laws</p>
<p class="FMaltPara">LL.D. = Doctor of Laws</p>
<p class="FMaltPara">LL.M. = Master of Laws</p>
<p class="FMaltPara">LPN = Licensed Practical Nurse</p>
<p class="FMaltPara">LSM = Landing Ship Medium</p>
<p class="FMaltPara">LST = Landing Ship Tank</p>
<p class="FMaltPara">LSU = Louisiana State University</p>
<p class="FMaltPara">Lt. = Lieutenant</p>
</div>
<div class="extract">
<p class="FMaltPara">m. = married</p>
<p class="FMaltPara">Maj. = Major</p>
<p class="FMaltPara">marr. = marriage</p>
<p class="FMaltPara">MassDI = Massachusetts Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">M.A.T. = Master of Arts in Teaching</p>
<p class="FMaltPara">MichDI = Michigan Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">MinnBI = Minnesota Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">MinnDI = Minnesota Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">MissMI = Mississippi Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">MIT = Massachusetts Institute of Technology</p>
<p class="FMaltPara">M.L.S. = Master in Library Science</p>
<p class="FMaltPara">M.M.Sc. = Master of Medical Science</p>
<p class="FMaltPara">MoDI = Missouri Death Index (Missouri Death Records, database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">MoMI = Missouri Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">MontDI = Montana Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">mss. = manuscript(s)</p>
<p class="FMaltPara">M.St. = Master of Studies</p>
<p class="FMaltPara">M.S.W. = Master of Social Work</p>
<p class="FMaltPara">M.Th. = Master of Theology</p>
</div>
<div class="extract">
<p class="FMaltPara">NASW = National Association of Social Workers</p>
<p class="FMaltPara">Natl. = National</p>
<p class="FMaltPara">NCarBI = North Carolina Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">NCarDI = North Carolina Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">NCarMI = North Carolina Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">NCO = Non-Commissioned Officer</p>
<p class="FMaltPara">n.d. = no date (of publication) indicated</p>
<p class="FMaltPara">NevMI = Nevada Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">New York Passenger Lists = New York Passenger Lists, 1820–1957 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">NIH = National Institutes of Health</p>
<p class="FMaltPara">n.p. = no place (of publication) indicated</p>
<p class="FMaltPara">N.S. = New Series</p>
<p class="FMaltPara">NSCDA = See CDA</p>
<p class="FMaltPara">NSDAR = see DAR</p>
<p class="FMaltPara">NSSAR = see SAR</p>
<p class="FMaltPara">NSWFD = The National Society of the Washington Family Descendants</p>
<p class="FMaltPara">NYU = New York University</p>
</div>
<div class="extract">
<p class="FMaltPara">OCS = Officer Candidate School</p>
<p class="FMaltPara">OhBI = Ohio Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">OhDI = Ohio Death Index (“Ohio Deaths,” database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">on-line census index = that provided by <a href="http://Ancestry.com" target="_blank">Ancestry.com</a></p>
<p class="FMaltPara">OreDI = Oregon Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">OWT = One World Tree (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
</div>
<div class="extract">
<p class="FMaltPara">p. = page (pp. = pages)</p>
<p class="FMaltPara">PFC = Private First Class</p>
<p class="FMaltPara">PMT = Public Member Tree (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">POW = Prisoner of War</p>
<p class="FMaltPara">P.P. = Prentiss Price (of Rogersville, Tenn.; an exceptionally gifted genealogist, for many years he collaborated extensively with John Augustine Washington [of Chevy Chase, later Bethesda, Md.], whose “Outline” is the basis for much of the current book).</p>
<p class="FMaltPara">PRF = Pedigree Resource File (database on <a href="http://FamilySearch.org" target="_blank">FamilySearch.org</a>)</p>
<p class="FMaltPara">Prof. = Professor</p>
</div>
<div class="extract">
<p class="FMaltPara">q.v. = whom see (<em class="italic">quem vide</em>)</p>
</div>
<div class="extract">
<p class="FMaltPara">RAF = Royal Air Force</p>
<p class="FMaltPara">Reg. = Register/Registration</p>
<p class="FMaltPara">Regt. = Regiment</p>
<p class="FMaltPara">Rev. War = Revolutionary War</p>
<p class="FMaltPara">RhodeIslandMI = Rhode Island Marriage Records (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">R.N. = Registered Nurse</p>
<p class="FMaltPara">RN = Royal Navy</p>
<p class="FMaltPara">ROTC = Reserve Officers Training Corps</p>
</div>
<div class="extract">
<p class="FMaltPara">SAR = National Society, Sons of the American Revolution</p>
<p class="FMaltPara">SAR Membership Applications = U.S., Sons of the American Revolution Membership Applications, 1889–1970 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">SCarDI = South Carolina Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">S.C., Clemson U. (Ag. College) = South Carolina, Clemson University (Agricultural College) Directory of Graduates, 1896–1940 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">S.C., Clemson U. Student Military Records = South Carolina, Clemson University Student Military Service Records, 1894–1944 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">S.C. Delayed Births = South Carolina Delayed Births, 1766–1900 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">SCV = Sons of Confederate Veterans</p>
<p class="FMaltPara">SDakMI = South Dakota Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">Ser. = Series</p>
<p class="FMaltPara">Sgt. = Sergeant</p>
<p class="FMaltPara">SMU = Southern Methodist University</p>
<p class="FMaltPara">SSDI = Social Security Death Index</p>
<p class="FMaltPara">S.T.D. = Doctor of Sacred Theology</p>
<p class="FMaltPara">S.T.M. = Master of Sacred Theology</p>
<p class="FMaltPara">SUNY = State University of New York</p>
</div>
<div class="extract">
<p class="FMaltPara">TennBI = Tennessee Birth Index (Tennessee, Delayed Birth Records, database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">TennDI = Tennessee Death Index (Tennessee Deaths and Burials Index, database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">TennMI = Tennessee Marriage Index (Tennessee State Marriages, database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">TexBI = Texas Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>; these extremely useful records are also available at <a href="http://http://www.tdh.state.tx.us/bvs/registra/index.htm" target="_blank">http://www.tdh.state.tx.us/bvs/registra/index.htm</a>)</p>
<p class="FMaltPara">TexDI = Texas Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">TexDivI = Texas Divorce Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">TexMI = Texas Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
</div>
<div class="extract">
<p class="FMaltPara">UCLA = University of California-Los Angeles</p>
<p class="FMaltPara">UCV = United Confederate Veterans</p>
<p class="FMaltPara">UDC = United Daughters of the Confederacy</p>
<p class="FMaltPara">unm. = unmarried</p>
<p class="FMaltPara">U.P. = University Press</p>
<p class="FMaltPara">U.S.(A.) = United States (of America)</p>
<p class="FMaltPara">USA = U.S. Army</p>
<p class="FMaltPara">USAF = U.S. Air Force (also used for U.S. Army Air Corps and U.S. Army Air Force)</p>
<p class="FMaltPara">USA, Register of Enlistments = U.S. Army, Register of Enlistments, 1798–1914 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">U. of S.C. = University of South Carolina</p>
<p class="FMaltPara">USCG = U.S. Coast Guard</p>
<p class="FMaltPara">USDA = U.S. Department of Agriculture</p>
<p class="FMaltPara">USMA = U.S. Military Academy, West Point, N.Y.</p>
<p class="FMaltPara">USMC = United States Marine Corps</p>
<p class="FMaltPara">USMCR = United States Marine Corps Reserve</p>
<p class="FMaltPara">USMilRecords, 1925 = U.S. Military Records, 1925: Official National Guard Register (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">USN = U.S. Navy</p>
<p class="FMaltPara">USNA = U.S. Naval Academy, Annapolis, Md.</p>
<p class="FMaltPara">USO = United Service Organizations (a non-profit organization to support U.S. Armed Forces)</p>
<p class="FMaltPara">U.S. Passport Applications = U.S. Passport Applications, 1795–1925 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">USPRI = U.S. Public Records Index (database available on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">U.S. Veterans Cemeteries = U.S. Veterans Cemeteries, ca. 1806–2006 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">U.S. Veterans Gravesites = U.S. Veterans Gravesites, ca. 1775–2006 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">U.S. WW II Navy Muster Rolls = U.S. World War II Navy Muster Rolls, 1938–1949 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
</div>
<div class="extract">
<p class="FMaltPara">VaMarrI = Virginia Marriage Index (“Virginia Marriages, 1851–1900”; database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">VMI = Virginia Military Institute</p>
<p class="FMaltPara">vols. = volumes</p>
<p class="FMaltPara">Vols. = Volunteers</p>
<p class="FMaltPara">VPI = Virginia Polytechnic Institute (now Virginia Tech)</p>
</div>
<div class="extract">
<p class="FMaltPara">W(A)AC = Women’s (Auxiliary) Army Corps (WW II-era women’s branch of the U.S. Army)</p>
<p class="FMaltPara">WashBI = Washington (State) Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WashDI = Washington (State) Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WashMI = Washington (State) Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WAVE(S) = Women Accepted for Volunteer Emergency Service (WW II-era women’s branch of the U.S. Navy)</p>
<p class="FMaltPara">WCP = World Connect Project (database on <a href="http://RootsWeb.com" target="_blank">RootsWeb.com</a>)</p>
<p class="FMaltPara">WiscDI = Wisconsin Death Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WiscMI = Wisconsin Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WPA = Works Progress Administration</p>
<p class="FMaltPara">WVaBI = West Virginia Birth Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WVaMI = West Virginia Marriage Index (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WW I Draft Reg. = WW I Civilian Draft Registrations (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WW II AER = U.S. World War II Army Enlistment Records (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WW II &amp; KCV = World War II and Korean Conflict Veterans Interred Overseas Record (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WW II Draft Reg. = WW II Civilian Draft Registration Cards (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WW II POWs = World War II Prisoners of War, 1941–1946 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WW II USN Aircraft Carrier Muster Rolls = WW II U.S. Navy Aircraft Carrier Muster Rolls (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p>
<p class="FMaltPara">WW II USN, USMC, &amp; USCG Casualties = WW II Navy, Marine Corps, and Coast Guard Casualties, 1941–1945 (database on <a href="http://Ancestry.com" target="_blank">Ancestry.com</a>)</p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_abbreviation.vue?21429d96